<div id="{{appName}}" class="component-wrapper">
    <div class="footer-resources-container" *ngIf="appName ==='toyota'">
        <div class="footer-resource-container-wrapper">
            <div class="row" style="align-items: center;">
                <div class="col-sm-6">
                    <a (click)="onLogoClick()" href="{{logoPath}}">
                        <img alt="External-logo" *ngIf="appName==='toyota' && !isInternal" class="footer-logo footer-logocts" [src]="commonService.commonFiles['external-logo']">
                        <img alt="Internal-logo" *ngIf="appName==='toyota' && isInternal" class="footer-logo" [src]="commonService.commonFiles['internal-logo']">
                    </a>
                </div>
                <div class="col-sm-6" *ngFor="let key of resources | keys">
                    <div class="footer-section-wrapper">
                        <h3 class="footer-section-title"> {{key}} </h3>
                        <div class="footer-section-content" *ngIf="!isInternal">
                            <ul *ngIf="resources[key] && resources[key].length">
                                <li *ngFor="let doc of resources[key]">
                                    <a *ngIf="doc.resourceTitle !== 'Smartphone Compatibility' && doc.resourceTitle !== 'Public Site'" rel="noopener noreferrer" (click)="openFileInNewTab($event,doc.resourceUrl)"
                                        target="_blank" href="{{doc.resourceUrl}}">{{doc.resourceTitle}}</a>
                                    <a *ngIf="doc.resourceTitle === 'Smartphone Compatibility'" rel="noopener noreferrer" target="_blank" [routerLink]="doc.resourceUrl">{{doc.resourceTitle}}</a>
                                        
                                </li>
                            </ul>
                        </div>

                        <div class="footer-section-content" *ngIf="isInternal">
                            <ul *ngIf="resources[key] && resources[key].length">
                                <li class="external" *ngFor="let doc of resources[key]">
                                    <a *ngIf="doc.resourceTitle !== 'Smartphone Compatibility'" rel="noopener noreferrer" (click)="openFileInNewTab($event,doc.resourceUrl)"
                                        target="_blank" href="{{doc.resourceUrl}}">{{doc.resourceTitle}}</a>
                                    <a *ngIf="doc.resourceTitle === 'Smartphone Compatibility'" rel="noopener noreferrer" [routerLink]="doc.resourceUrl">{{doc.resourceTitle}}</a>
                                    
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-resources-container" *ngIf="appName ==='lexus'">
        <div class="footer-resource-container-wrapper">
            <div class="row" style="align-items: center;">
                <div class="col-sm-6">
                    <a (click)="onLogoClick()" href="{{logoPath}}">
                        <img alt="External-logo" *ngIf="appName==='lexus' && !isInternal" class="footer-logocts" [src]="commonService.commonFiles['external-logo']">
                        <img alt="Internal-logo" *ngIf="appName==='lexus' && isInternal" class="footer-logo" [src]="commonService.commonFiles['internal-logo']">
                    </a>
                </div>
                <div class="col-sm-6" *ngFor="let key of resources | keys">
                    <div class="footer-section-wrapper">
                        <h3 class="footer-section-title"> {{key}} </h3>
                        <div class="footer-section-content" *ngIf="!isInternal">
                            <ul *ngIf="resources[key] && resources[key].length">
                                <li *ngFor="let doc of resources[key]">
                                    <a *ngIf="doc.resourceTitle !== 'Public Site'" (click)="openFileInNewTab($event,doc.resourceUrl)" rel="noopener noreferrer" target="_blank" href="{{doc.resourceUrl}}">{{doc.resourceTitle}}</a>
                                </li>
                            </ul>
                        </div>
                        <div class="footer-section-content footer-external" *ngIf="isInternal">
                            <ul *ngIf="resources[key] && resources[key].length">
                                <li class="external" *ngFor="let doc of resources[key]">
                                    <a (click)="openFileInNewTab($event,doc.resourceUrl)" rel="noopener noreferrer" target="_blank" href="{{doc.resourceUrl}}">{{doc.resourceTitle}}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>